import React, { useMemo } from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { listCycles } from '../../utils/attendanceCycle';
import { SELECTED_MENU_PROPS } from '../StyledComponents/StyledComponent';

/**
 * Dropdown of recent 26→25 attendance cycles.
 *
 * @param {string} value   canonical cycle param ("YYYY-MM" of the start month)
 * @param {(cycle:string)=>void} onChange  receives the selected cycle param
 * @param {number} count   how many recent cycles to list (default 12)
 * @param {string} label   field label (default "Cycle (26–25)")
 */
const CycleSelector = ({ value, onChange, count = 12, label = 'Cycle (26–25)', size = 'small', fullWidth = true }) => {
  const cycles = useMemo(() => listCycles(count), [count]);

  return (
    <FormControl size={size} fullWidth={fullWidth}>
      <InputLabel>{label}</InputLabel>
      <Select value={value || ''} label={label} onChange={(e) => onChange(e.target.value)} MenuProps={SELECTED_MENU_PROPS}>
        {cycles.map((c) => (
          <MenuItem key={c.cycle} value={c.cycle}>
            {c.label} &nbsp;·&nbsp; {c.payrollMonthName} {c.payrollYear}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default CycleSelector;
